export function gotoDashboard() {
  window.location.href = '/dashboard'
}

export function gotoTickets() {
  window.location.href = '/dashboard/tickets'
}

export function gotoSignOut(redirectTo) {
  window.location.href = `/sign-out?redirectTo=${redirectTo}`
}

export function gotoSignIn(redirectTo) {
  window.location.href = `/sign-in?redirectTo=${redirectTo}`
}

export function gotoHomepage() {
  window.location.href = '/'
}

export function gotoEventManager(eventSlug, page) {
  window.location.href = `${BASE_URL}${page !== 'promote' ? '/host' : ''}/events/${eventSlug}/${page}`
}

export function gotoTagSearch(tagSlug) {
  window.location.href = `${BASE_URL}/explore?query=${tagSlug}`
}

export function gotoDiscover() {
  window.location.href = '/explore'
}

// NOTE: https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/parameter-reference1
export function shareToTwitter(listingSlug, listingText, isEventSet) {
  const url = `${BASE_URL}/${isEventSet ? 'calendars' : 'events'}/${listingSlug}`
  const text = `${listingText}+%40uniiverse`

  window.open(
    `https://twitter.com/intent/tweet?&text=${text}&related=uniiverse&url=${url}`,
    'share',
    'top=0, left=0, height=250, width=500, location=no, toolbar=no',
  )
}

export function shareToFacebook(listingSlug, isEventSet) {
  const url = `${BASE_URL}/${isEventSet ? 'calendars' : 'events'}/${listingSlug}`

  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    'share',
    'top=0, left=0, height=250, width=500, location=no, toolbar=no',
  )
}

export const signInPath = () => (
  SSR_DATA.prerendering ? '/sign-in' : `/sign-in?redirectTo=${window.location.href}`
)
